import React from 'react'

import { Align, Button, Heading, Margin, TextStyle, Popup, Spacer } from 'component-library-next'

export type Props = {
  setMessageIdToDelete: (messageId: number | undefined) => void
  messageIdToDelete: number
  deleteMessage: (messageId: number) => void
}

export const ConfirmMessageDeletePopUp = ({
  setMessageIdToDelete,
  messageIdToDelete,
  deleteMessage
}: Props) => {
  return (
    <Popup
      onClose={() => setMessageIdToDelete(undefined)}
      onCloseButtonClick={() => setMessageIdToDelete(undefined)}
    >
      <Align direction={Align.directions.center} textAlign={Align.textAligns.center}>
        <Heading size={Heading.sizes.small} color={Heading.colors.black}>
          Nachricht und angehängte Dateien löschen?
        </Heading>
      </Align>
      <TextStyle>
        Die Nachricht und die angehängten Dateien werden unwiderruflich gelöscht.
      </TextStyle>
      <Spacer />
      <Align direction={Align.directions.center}>
        <Margin>
          <Button
            onClick={() => {
              deleteMessage(messageIdToDelete)
              setMessageIdToDelete(undefined)
            }}
            color={Button.colors.warning}
          >
            löschen
          </Button>
        </Margin>
        <Margin>
          <Button onClick={() => setMessageIdToDelete(undefined)} color={Button.colors.minor}>
            zurück
          </Button>
        </Margin>
      </Align>
    </Popup>
  )
}
